/**
 * Переходи з головної у відфільтровані списки. Кожне посилання відтворює правило
 * лічильника (DashboardSummaryAction), тож число на головній збігається зі списком;
 * вибраний диспетчер переноситься у фільтр списку.
 */

/** Диспетчер, дані якого показує головна (вибраний у фільтрі або сам диспетчер) */
export interface LinkDispatcher {
    uuid: string
    name: string
}

export type TaskSource = 'requests' | 'standalone'

/** Підписи посилань на дві сторінки задач: «з заявками N · без заявок M» */
export const TASK_SOURCE_LABELS: Record<TaskSource, string> = { requests: 'з заявками', standalone: 'без заявок' }

const TASK_PAGES: Record<TaskSource, string> = {
    requests: '/assignments/with-requests',
    standalone: '/assignments/without-requests',
}

const withQuery = (path: string, params: Record<string, string>): string => {
    const query = new URLSearchParams(params).toString()
    return query ? `${path}?${query}` : path
}

/**
 * Список задач однієї зі сторінок (з заявками / без) з умовами (`status`, `delayStatus`,
 * `noDriver`, `noVehicle` — див. assignmentFilterFromQuery) і диспетчером.
 */
export const tasksUrl = (
    source: TaskSource,
    conditions: Record<string, string>,
    dispatcher: LinkDispatcher | null
): string =>
    withQuery(TASK_PAGES[source], {
        ...conditions,
        ...(dispatcher ? { dispatcher: dispatcher.uuid, dispatcherName: dispatcher.name } : {}),
    })

/** Список заявок зі статусом і відповідальним диспетчером (фільтр filterDispatcher, IRI) */
export const requestsUrl = (status: string, dispatcher: LinkDispatcher | null): string =>
    withQuery('/requests', {
        status,
        ...(dispatcher ? { filterDispatcher: `/services/users/${dispatcher.uuid}` } : {}),
    })
